import { usePlatformAbilities } from '@/hooks/usePlatformAbilities';

// O hero "Continuar" aparece sempre que o Guia de Estudos está habilitado pra
// esse aluno — diferente da Trilha (que só existia enquanto o aluno já tinha
// uma trilha ativa gerada), o Guia de Estudos semanal sempre tem o que mostrar.
export function useGuiaDeEstudosEnabled() {
  const { abilities } = usePlatformAbilities();
  return !!abilities?.['plano-de-estudo'];
}
